import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-attachment2',
  templateUrl: './attachment2.component.html',
  styleUrls: ['./attachment2.component.css']
})
export class Attachment2Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
